module.exports = {"510302001":"五星街街道","510302002":"东兴寺街道","510302003":"新街街道","510302004":"郭家坳街街道","510302005":"丹桂街道","510302006":"学苑街道","510302101":"仲权镇","510302102":"舒坪镇","510302103":"荣边镇","510302201":"红旗乡","510302202":"高峰乡","510302203":"农团乡","510302204":"漆树乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510302.json
// module id = 2095
// module chunks = 0